// SEARCH
(function () {
  var shippingTable = $('.shipping_table:not(.shipping_table_fixed) table');

  function myFunction() {
    var input, filter, table, tr, td, i, j, searchflag,  countryArray;
    input = document.getElementById("myInput");
    table = document.getElementById("myTable");
    if (input && table) {
      filter = input.value.toUpperCase();
      tr = table.getElementsByTagName("tr");

      if (filter.length > 0) {
        for (i = 0; i < tr.length; i++) {
          td = tr[i].getElementsByTagName("td")[0];
          if (td) {

            countryArray = td.innerHTML.toUpperCase().split(' ');
            searchflag = false;

            for (j = 0; j < countryArray.length ; j++) {
              if ((countryArray[j].indexOf(filter) > -1 && filter.length > 2) || (countryArray[j].indexOf(filter) == 0 && filter.length < 3)) {
                searchflag = true;
                break;
              }
            }

            if (searchflag === true) {
              tr[i].style.display = "";
            } else {
              tr[i].style.display = "none";
            }


          }       
        }
      } else {
        shippingTable.find("tr").css({display:""});
      }

    }

    shippingTable.find("tr").removeClass("even").removeClass("odd");
    shippingTable.find("tr:visible:even").addClass("even");
    shippingTable.find("tr:visible:odd").addClass("odd");

  }

  $("#myInput")
  .on('input', myFunction)
  .on('focus',function() {
    $("#shipping-search-input").css({'box-shadow':'0px 0px 10px 0px rgba(38,38,38,0.25)'});
  })
  .on('blur',function() {
    $("#shipping-search-input").css({'box-shadow':'none'});
  });

  myFunction();
})();

// FIXED HEADER
(function () {
  var table = document.querySelector('.shipping_table:not(.shipping_table_fixed) table');
  if (table.clientHeight < 200) {
    return; 
  }

  var tableHead = table.querySelector('thead');
  var tableHeadHeight = tableHead.clientHeight;
  var scroll = document.querySelector('.shipping_table:not(.shipping_table_fixed) .shipping_table-wrapper');

  var header = document.getElementById('wb-hdr19');

  var fixed = document.querySelector('.shipping_table_fixed');
  var fixedTable = fixed.querySelector('table');
  var fixedHead;
  var fixedScroll = fixed.querySelector('.shipping_table-wrapper');

  function debounce(func) {
    var wait = arguments.length <= 1 || arguments[1] === undefined ? 100 : arguments[1];

    var timeout = void 0;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timeout);
      timeout = setTimeout(function () {
        func.apply(_this, args);
      }, wait);
    };
  }

  function updateFixedVisibility () {
    var headerRect = header.getBoundingClientRect();
    var contentOffset = headerRect.height - Math.abs(headerRect.top);

    var scrollY = window.scrollY || window.pageYOffset;
    var shouldShowFixed = scrollY + contentOffset > table.offsetTop && scrollY + contentOffset < table.offsetTop + table.clientHeight - tableHeadHeight;

    if (shouldShowFixed) {
      fixed.classList.add('show'); 
      fixed.style.top = contentOffset + 'px';
    } else {
      fixed.style.top = '';
      fixed.classList.remove('show');
    }
  }

  function setupFixedTable () {
    if (fixedTable.childElementCount == 0) {
      fixedHead = tableHead.cloneNode(true);
      fixedTable.innerHTML = '';
      fixedTable.appendChild(fixedHead);
    }
    var tableHeadWidths = [].slice.call(tableHead.querySelectorAll('th')).map(function (th) { return th.clientWidth; });
    [].slice.call(fixedHead.querySelectorAll('th')).forEach(function (th, index) { th.style.width = tableHeadWidths[index] + 'px'; });

    updateFixedVisibility();  
  }

  function bindEventListeners () {
    window.addEventListener('scroll', updateFixedVisibility, { passive: true });
    window.addEventListener('resize', setupFixedTable, { passive: true }); 
  }

  document.addEventListener('DOMContentLoaded', function () {
    if ((window.scrollY || window.pageYOffset) > 0) {
      // Delay and wait until banner and top are hidden
      setTimeout(function () { 
        setupFixedTable();
        bindEventListeners();
      }, 300); 
    } else {
      setupFixedTable();
      bindEventListeners();
    }
  });

  var scrollSyncDebounced = debounce(function () {
    fixedScroll.scrollLeft = scroll.scrollLeft;
  }, 4);

  scroll.addEventListener('scroll', scrollSyncDebounced,  { passive: true });

})();